import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { MatchButton } from "../TransferMatching/MatchButton/MatchButton";

interface MatchingActionCellMeta {
    originTransaction: TransactionListItem;
    pairedTransaction: TransactionListItem | null;
    onMatch: (
        originTransaction: TransactionListItem,
        targetTransaction: TransactionListItem,
    ) => void;
    onUnmatch: () => void;
}

export const MatchingActionCell = ({
    row,
    table,
}: CellContext<ViewTableFeatures, TransactionListItem, unknown>) => {
    const targetTransaction = row.original;
    const { options } = useViewTableMeta<unknown, MatchingActionCellMeta>(
        table,
    );

    if (!options) {
        return null;
    }

    const { originTransaction, pairedTransaction, onMatch, onUnmatch } =
        options;

    return (
        <ViewTableCell captureClicks>
            <MatchButton
                matchedTransaction={pairedTransaction}
                originTransaction={originTransaction}
                targetTransaction={targetTransaction}
                onMatch={onMatch}
                onUnmatch={onUnmatch}
            />
        </ViewTableCell>
    );
};
